import type { CSSProperties } from 'react';

/** 24 px grid, single-path stroke icons drawn for this project (also in assets/svg/icons). */
export const ICONS = {
  check: 'M5 12.5l4.5 4.5L19 7.5',
  x: 'M6 6l12 12M18 6L6 18',
  half: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18M12 3v18',
  dash: 'M6 12h12',
  dot: 'M12 9.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5',
  lock: 'M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  pause: 'M9 5v14M15 5v14',
  play: 'M7 4.5l12 7.5-12 7.5z',
  skip: 'M5 5l9 7-9 7zM18 5v14',
  flag: 'M5 21V4h11l-2 4 2 4H5',
  plus: 'M12 5v14M5 12h14',
  wifi: 'M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0M2 8.8a15 15 0 0 1 20 0M12 20h.01',
  wifiOff: 'M3 3l18 18M8.5 16.5a5 5 0 0 1 7 0M5 12.5a10 10 0 0 1 4-2.3M19 12.5a10 10 0 0 0-2.4-1.7M2 8.8a15 15 0 0 1 4.2-2.6M22 8.8A15 15 0 0 0 11 5M12 20h.01',
  refresh: 'M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7',
  volume: 'M4 9h4l5-4v14l-5-4H4zM16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12',
  mute: 'M4 9h4l5-4v14l-5-4H4zM17 9l5 6M22 9l-5 6',
  up: 'M12 19V5M6 11l6-6 6 6',
  down: 'M12 5v14M6 13l6 6 6-6',
  grip: 'M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01',
  chevron: 'M9 6l6 6-6 6',
  user: 'M12 12a4 4 0 1 0 0-8a4 4 0 1 0 0 8M4 20a8 8 0 0 1 16 0',
  info: 'M12 8h.01M11 12h1v5h1M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18',
  image: 'M4 5h16v14H4zM4 15l5-5 5 5M13 13l2-2 5 5M15 9h.01',
  external: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
  tv: 'M3 6h18v11H3zM8 21h8M12 17v4',
  same: 'M5 9h14M5 15h14',
} as const;
export type IconName = keyof typeof ICONS;

export function Icon({ name, size, style, label }: { name: IconName; size?: number | string; style?: CSSProperties; label?: string }) {
  return (
    <svg className="ex-ico" viewBox="0 0 24 24" style={{ ...(size ? { fontSize: size } : null), ...style }}
      aria-hidden={label ? undefined : true} role={label ? 'img' : undefined} aria-label={label}>
      <path d={ICONS[name]} />
    </svg>
  );
}

export const STAR_PATH = 'M12.00 1.00 L14.70 8.28 L22.46 8.60 L16.37 13.42 L18.47 20.90 L12.00 16.60 L5.53 20.90 L7.63 13.42 L1.54 8.60 L9.30 8.28Z';
/** Maple leaf path from flag-icons 7.2.3 (MIT, Panayiotis Lipiridis). viewBox 118 98 278 304. */
export const LEAF_PATH = 'M135.3 247.4l-14 4.8 65.4 57.5c5 14.8-1.7 19.1-6 26.9l71-9-1.8 71.5 14.8-.5-3.3-70.9 71.2 8.4c-4.4-9.3-8.3-14.2-4.3-29l65.4-54.5-11.4-4.1c-9.4-7.3 4-34.8 6-52.2 0 0-38.1 13.1-40.6 6.2l-9.9-18.5-34.6 38c-3.8 1-5.4-.6-6.3-3.8l16-79.7-25.4 14.3c-2.1.9-4.2 0-5.6-2.4l-24.5-49-25.2 50.9c-1.9 1.8-3.8 2-5.4.8l-24.2-13.6 14.5 79.2c-1.1 3-3.9 4-7.1 2.3l-33.3-37.8c-4.3 7-7.3 18.4-13 21-5.7 2.3-25-4.9-37.9-7.7 4.4 15.9 18.2 42.3 9.5 51z';

export function MapleLeaf({ size = 30, color = '#D52B1E', style }: { size?: number; color?: string; style?: CSSProperties }) {
  return (
    <svg viewBox="118 98 278 304" width={size} height={Math.round(size * 1.1)} aria-hidden="true" style={{ flex: 'none', ...style }}>
      <path d={LEAF_PATH} fill={color} />
    </svg>
  );
}
